// src/locales/index.js

// 引入各个语言的 JSON 文件
import en from './en.json';
import zh from './zh.json';
import fr from './fr.json';
import ja from './ja.json';

// 导出所有语言包
export default {
    en,
    zh,
    fr,
    ja
}; // 移除了末尾的逗号
